<template>
  <div>
    <p>Create your loyalty program</p>
    <a-row>
      <a-col :span="24">
        <a-card title="Loyalty Program Settings" style="margin: 20px 0;">
          <p>I want my loyalty program to be called (internal use only):</p>
          <a-input size="large"
                   placeholder="<storename>_LoyaltyCard0001"
                   @change="onLoyaltyDataChange('name', $event.target.value)"
                   :value="loyaltyData.name"
                   name="name"
                   v-validate="'required'"
          />
          <span class="form-error" v-if="errors.first('name')">{{errors.first('name')}}</span>
          <div>
            <span>I want to have</span>
            <a-select defaultValue="unlimited"
                      size="large"
                      style="width: 120px"
                      @change="onLoyaltyDataChange('max_count', $event)"
                      :value="loyaltyData.max_count"
            >
              <a-select-option value="10" disabled>10</a-select-option>
              <a-select-option value="100" disabled>100</a-select-option>
              <a-select-option value="1000" disabled>1000</a-select-option>
              <a-select-option :value="null">unlimited</a-select-option>
              <a-select-option value="custom" disabled>custom</a-select-option>
            </a-select>

            <span>cards available for my members.</span>
          </div>
        </a-card>
        <a-card title="Loyalty Card Settings">
          <div>
            <span>I want each loyalty card to be valid for</span>
            <a-select style="width: 120px" :defaultValue="12" @change="onLoyaltyDataChange('valid_for_months', $event)"
                      :value="loyaltyData.valid_for_months">
              <a-select-option value="1" >1</a-select-option>
              <a-select-option value="3" >3</a-select-option>
              <a-select-option value="6" >6</a-select-option>
              <a-select-option value="12" >12</a-select-option>
              <a-select-option value="18" >18</a-select-option>
              <a-select-option value="24" >24</a-select-option>
            </a-select>
            <span>months.</span>
          </div>
          <p>During this period, I want to incentivize my customers to purchase:</p>
          <a-input size="large"
            placeholder="e.g. a large coffee, a haircut, a manicure, a full body massage..."
            @change="onLoyaltyDataChange('card_name', $event.target.value)"
            :value="loyaltyData.card_name"
             name="card name"
             v-validate="'required'"
          />
          <span class="form-error" v-if="errors.first('card name')">{{errors.first('card name')}}</span>
          <div>
            <span>from my business</span>
            <a-input-number size="large"
                            :min="1"
                            :max="20"
                            @change="onLoyaltyDataChange('purchase_count', $event)"
                            :value="loyaltyData.purchase_count"
            />
            <span>times.</span>
          </div>
          <p><b>Point Collection</b> Terms and Conditions</p>
          <a-textarea placeholder="Basic usage"
                      :rows="4"
                      @change="onLoyaltyDataChange('terms', $event.target.value)"
                      :value="loyaltyData.terms"
          />
        </a-card>

        <a-card title="Reward to encourage your customers" style="margin: 20px 0;">
          <p>The reward I want to give after they complete this card is a:</p>
          <a-input size="large"
                   placeholder="e.g. a large coffee, a haircut, a manicure, a full body massage..."
                   @change="onLoyaltyOfferChange('name', $event.target.value)"
                   :value="loyaltyData.offer.name"
                   name="reward name"
                   v-validate="'required'"
          />
          <span class="form-error" v-if="errors.first('reward name')">{{errors.first('reward name')}}</span>
          <div>
            <span>My customer will have</span>
            <a-input-number size="large"
                            :min="1"
                            :max="1000"
                            @change="onLoyaltyOfferChange('reward_expire_days', $event)"
                            :value="loyaltyData.offer.reward_expire_days"
            />
            <span>days to use this reward before it expires.</span>
          </div>
          <div class="clearfix">
            <a-upload
              :fileList="fileList"
              :change="handleRemove"
              listType="picture"
              @remove="fileList = []"
              :beforeUpload="beforeUpload"
            >
              <a-button>
                <a-icon type="upload" /> Select reward image
              </a-button>
            </a-upload>
          </div>
          <p><b>Reward</b> Terms and Conditions</p>
          <a-textarea placeholder="Basic usage"
                      :rows="4"
                      @change="onLoyaltyOfferChange('terms', $event.target.value)"
                      :value="loyaltyData.offer.terms"
          />
          <div style="display: flex;justify-content: space-between;margin: 10px 0;">
            <span>Automatically issue a new card to members when their current card is completed?</span>
            <a-switch @change="onChange"
                      :checked="loyaltyData.auto_reissue"
            />
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-button type="primary"
              :disabled="!edited"
              style="margin: 10px auto;display: flex;"
              @click="saveLoyalty">
      Save Changes
    </a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {API_URL} from '../../constants'

export default {
  name: 'CreateNewCard',
  data () {
    return {
      message: '',
      API_URL,
      loading: false,
      imageUrl: '',
      fileList: [],
      edited: false,
    }
  },
  mounted () {
    if (!this.loyaltyData.offer) {
      this.$store.dispatch('loyalty/newLoyaltyProgram')
    }

    this.$store.dispatch('loyalty/getLoyaltyData')
    if (this.loyaltyData.offerImage) {
      this.fileList = [{
        uid: this.loyaltyData.offerImage.id,
        name: this.loyaltyData.offerImage.image,
        status: 'don',
        url: `${API_URL}${this.loyaltyData.offerImage.url}`,
      } ]
    }
  },
  watch: {
    'loyaltyData.offerImage': function (newImage) {
      this.fileList = [{
        uid: newImage.id,
        name: newImage.image,
        status: 'don',
        url: `${API_URL}${newImage.url}`,
      } ]
    }
  },
  methods: {
    onChange (checked) {
      this.edited = true
      this.$store.commit('loyalty/onLoyaltyDataChange', {field: 'auto_reissue', value: checked})
    },
    navigate (name) {
      this.$router.push({name})
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.edited = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      this.edited = true
      return false
    },
    onLoyaltyDataChange (field, value) {
      console.log(value)
      this.$store.commit('loyalty/onLoyaltyDataChange', {field, value})
      this.edited = true
    },
    onLoyaltyOfferChange (field, value) {
      this.$store.commit('loyalty/onLoyaltyOfferChange', {field, value})
      this.edited = true
    },
    async saveLoyalty () {
      const result = await this.$validator.validateAll()
      if (!result) {
        return
      }
      await this.$store.dispatch('loyalty/saveLoyalty', this.fileList.length && this.fileList[0])
      this.$router.push('manage')
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      loyaltyData: state => state.loyalty.loyaltyProgram,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .clearfix{
    margin: 20px 0;
  }
  .ant-upload-list-item-info{
    margin: 20px 0;
    color: #005cff;
  }
  .ant-input-number {
    margin:0 10px;
  }
  .ant-input {
    margin-bottom:15px;
  }
  .avatar-uploader > .ant-upload {
    width: 350px;
    height: 200px;
    margin: 20px auto;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }
  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .form-error {
    font-size: 14px;
    display: block;
    margin-top: -10px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loyalty/EditCard.vue